import { View } from "@common/types/views/views";

export const DEFAULT_TASK_FILTERS: View["filters"] = {};
